import React from 'react';
import style from './style.module.scss';

interface IInputOutline {
  value?: string,
  label?: string,
  name?: string,
  id?: string,
  onChange?: any
  error?: string
  placeholder?: string
}

const InputOutline = ({label, name, id, onChange, value, error, placeholder}: IInputOutline) => {
  return (
    <div className={style['InputOutline']}>
      {label && <div className={style['lable']}>{label}</div>}
      <input name={name} id={id} onChange={onChange} value={value} placeholder={placeholder} />
      {error && <div className={style['error']}>{error}</div>}
    </div>
  )
}

export default InputOutline;